import React, { useRef } from "react";

// 🔹 Bilder importieren
import img1 from "../bilder/umzug-galerie-01.jpg";
import img2 from "../bilder/umzug-galerie-02.jpg";
import img4 from "../bilder/umzug-galerie-04.jpg";
import img5 from "../bilder/umzug-galerie-05.jpg";
import img6 from "../bilder/umzug-galerie-06.jpg";
import img7 from "../bilder/umzug-galerie-07.jpg";
import img8 from "../bilder/umzug-galerie-08.png";
import img9 from "../bilder/umzug-galerie-09.jpeg";
import img10 from "../bilder/umzug-galerie-10.jpeg";
import img11 from "../bilder/umzug-galerie-11.jpeg";
import img12 from "../bilder/umzug-galerie-12.jpeg";
import img13 from "../bilder/umzug-galerie-13.jpeg";
import img14 from "../bilder/umzug-galerie-14.jpeg";
import img15 from "../bilder/umzug-galerie-15.jpeg";
import img16 from "../bilder/umzug-galerie-16.jpeg";
import img17 from "../bilder/umzug-galerie-17.jpeg";
import img18 from "../bilder/umzug-galerie-18.jpeg";
import img19 from "../bilder/umzug-galerie-19.jpeg";
import img20 from "../bilder/umzug-galerie-20.jpeg";
import img21 from "../bilder/umzug-galerie-21.jpeg";
import img22 from "../bilder/umzug-galerie-22.jpeg";
import img23 from "../bilder/umzug-galerie-23.jpeg";
import img24 from "../bilder/umzug-galerie-24.jpeg";
import img25 from "../bilder/umzug-galerie-25.jpeg";
import img26 from "../bilder/umzug-galerie-26.jpeg";
const images = [
  { src: img1, alt: "Umzugshelfer beim Tragen von Möbeln" },
  { src: img2, alt: "Beladener Transporter während eines Umzugs" },
  { src: img4, alt: "Möbelmontage nach dem Umzug" },
  { src: img5, alt: "Beladener Transporter während eines Umzugs" },
  { src: img6, alt: "Kartons ordentlich im neuen Zimmer platziert" },
  { src: img7, alt: "Möbelmontage nach dem Umzug" },
  { src: img8},
  { src: img9},
  { src: img10},
  { src: img11},
    { src: img12},
  { src: img13},
    { src: img14},
  { src: img15},
  { src: img16},
  { src: img17},
  { src: img18},
  { src: img19},
  { src: img20, alt: "Sorgfältig verpacktes Umzugsgut" },
  { src: img21, alt: "Möbel sicher im Transporter verstaut" },
  { src: img22, alt: "Geschütztes Umzugsgut im Transporter" },
  { src: img23, alt: "Beladener Umzugstransporter" },
  { src: img24, alt: "Umzugskartons und Möbel im Transporter" },
  { src: img25, alt: "Sicher verpackte Haushaltsgeräte für den Umzug" },
  { src: img26, alt: "Voll beladener Transporter mit Umzugsgut" },
];

export default function GallerySlider() {
  const sliderRef = useRef<HTMLDivElement | null>(null);

  const scroll = (dir: "left" | "right") => {
    if (!sliderRef.current) return;

    sliderRef.current.scrollBy({
      left:
        dir === "left"
          ? -sliderRef.current.clientWidth
          : sliderRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="max-w-[1100px] mx-auto px-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl md:text-3xl font-bold">
            Einblicke in unsere Arbeit
          </h2>

          <div className="hidden md:flex gap-2">
            <button
              onClick={() => scroll("left")}
              className="rounded-lg border px-3 py-2 hover:bg-slate-100"
              aria-label="Zurück"
            >
              ←
            </button>
            <button
              onClick={() => scroll("right")}
              className="rounded-lg border px-3 py-2 hover:bg-slate-100"
              aria-label="Weiter"
            >
              →
            </button>
          </div>
        </div>

        {/* Slider */}
        <div
          ref={sliderRef}
          className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2"
        >
          {images.map((img, i) => (
            <div
              key={i}
              className="
                snap-start
                min-w-[70%]
                sm:min-w-[45%]
                md:min-w-[30%]
                rounded-2xl
                overflow-hidden
                shadow
                bg-black
              "
            >
              {/* 9:16 Container */}
              <div className="aspect-[9/16] w-full">
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
